import { FormInlineErrorModule } from './../../shared/component/form-inline-error/form-inline-error.module';
import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared/modules/sharedComponentsModule';
import { PasswordResetPageModule } from "../password-reset-page/password-reset-page.module";


@NgModule({
    declarations: [
        LoginComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        FormInlineErrorModule,
        SharedComponentsModule,
        PasswordResetPageModule
    ]
})
export class LoginModule {}

